import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class AssetFamily implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Asset Family';
  public readonly apiRoute: string = CONFIG.apiRoutes.assetFamilies;

  assetFamilyId: string;
  assetFamilyName: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.assetFamilyId = data.assetFamilyId;
    this.assetFamilyName = data.assetFamilyName;
  }
}
